/* eslint-disable */

import "./style.sass";
const { SiteClient } = require("datocms-client");
window.DatoCmsPlugin.init(async (plugin) => {
  const client = new SiteClient(plugin.parameters.global.token);
  plugin.startAutoResizer();

  const button = document.createElement("button");
  button.classList.add("button");
  button.textContent = "Generate related items";

  button.style = `
  letter-spacing: 0;
  padding: .7em 1em;
  text-decoration: none;
  display: inline-block;
  vertical-align: middle;
  white-space: nowrap;
  font-family: inherit;
  cursor: pointer;
  line-height: inherit;
  background-color: transparent;
  color: #34363a;
  -webkit-appearance: none;
  -moz-appearance: none;
  border-radius: 4px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  -webkit-transition: all .3s cubic-bezier(.55,0,.1,1);
  transition: all .3s cubic-bezier(.55,0,.1,1);
  font-size: 1em;
  font-weight: 500;
  border: 1px solid transparent;
  background-color: var(--light-color);
  color: var(--accent-color);
  opacity: 1;
  height: 50px;
  
  `;

  document.body.appendChild(button);

  button.addEventListener("click", () => {
    generateRelatedArticles(client, plugin);
  });
});

const generateRelatedArticles = async (client, plugin) => {
  const selectedFields = plugin.parameters.instance.selectedField
    .replace(" ", "")
    .split(",");

  const exactFields = plugin.parameters.instance.priorityField
    .replace(" ", "")
    .split(",");

  let filteredFields = retrieveFields(selectedFields, plugin);
  let priorityFields = retrieveFields(exactFields, plugin, true);

  const foundItems = await client.items.all({
    filter: {
      type: plugin.itemType.id,
      fields: {
        ...filteredFields,
        ...priorityFields,
        id: {
          neq: plugin.itemId,
        },
      },
    },
    version: "latest",
  });

  const sortedItems = foundItems
    .map((item) => {
      let score = 0;
      for (let i = 0; i < selectedFields.length; i++) {
        let field = selectedFields[i];
        const fieldValues = plugin.getFieldValue(field);
        if (fieldValues && fieldValues.length !== 0) {
          score += item[field].filter((item) => fieldValues.includes(item))
            .length;
        }
      }
      item._score = score;
      return item;
    })
    .sort((a, b) => b._score - a._score)
    .slice(0, plugin.parameters.instance.amount);

  plugin.setFieldValue(plugin.fieldPath, [
    ...plugin.getFieldValue(plugin.fieldPath),
    ...sortedItems.map((item) => item.id),
  ]);
};

const retrieveFields = (fields, plugin, exact) => {
  const object = {};
  for (let i = 0; i < fields.length; i++) {
    let field = fields[i];
    const fieldValues = plugin.getFieldValue(field);
    if (fieldValues && fieldValues.length !== 0) {
      if (Array.isArray(fieldValues)) {
        let filterType = exact ? "allIn" : "anyIn";
        object[field] = {
          [filterType]: fieldValues,
        };
      } else {
        let filterType = exact ? "eq" : "in";
        object[field] = {
          [filterType]: fieldValues,
        };
      }
    }
  }
};
